import { mapActions, mapGetters } from 'vuex';
import EventBus from '../utils/event-bus';

export default {
  data() {
    return {
      translateDrag: null,
    };
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('keyup', this.onKeyUp);

    // todo: get the lance stuff and remove this, I think
    if (!this.selfPositioned) {
      $(this.$el).css({
        top: this.styles.top,
        left: this.styles.left,
      });
      this.createDraggable();
    }
  },
  computed: {
    ...mapGetters('panAndZoom', {
      panMode: 'getPanMode',
    }),
    ...mapGetters('graphicsTemplate', [
      'getElementParentGroupId',
      'getCanvas',
      'getSafeArea',
      'getAbsolutePosition',
      'getQueuedElement',
    ]),
    ...mapGetters('graphicsTemplate', {
      queuedElement: 'getQueuedElement',
    }),
  },
  watch: {
    panMode(v) {
      if (v) {
        this.translateDrag[0].disable();
        this.translateDrag[0].target.style.cursor = 'grab';
      } else {
        if (this.canTranslateDrag()) this.translateDrag[0].enable();
        this.translateDrag[0].target.style.cursor = 'auto';
        TweenMax.set(this.$el, this.tweenMaxTransforms);
      }
    },
    queuedElement(v) {
      if (v) {
        this.translateDrag[0].disable();
      } else {
        if (this.canTranslateDrag()) this.translateDrag[0].enable();
        TweenMax.set(this.$el, this.tweenMaxTransforms);
      }
    },
  },
  methods: {
    canTranslateDrag() {
      if (this.panMode || this.queuedElement) return false;
      const parent = this.parent && this.getElementById(this.parent);
      if (parent?.type === 'group' && !this.$store.state.templates.selectedGroups.has(this.parent)) {
        return false;
      }
      return !(this.element?.type === 'group' && this.editing);
    },
    ...mapActions('graphicsTemplate', [
      'onMoveOrResize',
      'setOneElementValueByProp',
    ]),
    updateElementProp(value, options) {
      return this.setOneElementValueByProp({ value, options });
    },
    createDraggable() {
      const self = this;
      let companions = [];
      let startX;
      let startY;

      EventBus.on('set-alignment', this.setAlignment);
      EventBus.on('snap-position', this.snapPosition);
      EventBus.on('sync-all', this.syncAll); // def still need this to keep multi select el in sync

      function setPosition() {
        if (self.element?.type === 'group') self.resetGroupPress();
        self.$store.dispatch('setTextEditing', false);
        self.updateStyles({
          id: self.id,
          propKey: 'top',
          propValue: this.y,
        });
        self.updateStyles({
          id: self.id,
          propKey: 'left',
          propValue: this.x,
        });

        const deltaX = this.x - startX;
        const deltaY = this.y - startY;

        // TODO: I believe the drag priority should be:
        // 1. Selected elements if clicked on directly
        // 2. Group if clicked on directly, ignoring any selected children
        // 3. Selected companion elements that are siblings, NOT parent/children
        for (let i = 0; i < companions.length; i += 1) {
          const selected = companions[i];
          const element = self.findElement(selected.id);

          if (element) {
            self.updateStyles({
              id: selected.id,
              propKey: 'top',
              propValue: selected.top + deltaY,
            });
            self.updateStyles({
              id: selected.id,
              propKey: 'left',
              propValue: selected.left + deltaX,
            });

            // Do we need these tweens now?
            TweenMax.set(selected.element, {
              left: selected.left + deltaX,
              top: selected.top + deltaY,
            });
          }
        }
      }

      function onPress(event) {
        if (event.button === 1) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        document.activeElement.blur(); // in case any inputs are focused
        startX = this.x;
        startY = this.y;

        if (self.element?.type === 'group' && self.onGroupPress(event)) return;

        if (!self.isSelected || event.shiftKey) {
          self.$emit('select', event, self.id);
        }

        companions = self.selectedElements
          .filter((id) => {
            if (self.getElementGroupMap && (
              self.getElementGroupMap[id]?.includes(self.id)
              || self.getElementGroupMap[self.id]?.includes(id)
            )) {
              return false;
            }

            const element = self.findElement(id);

            return (
              element
              && element.styles
              && !element.locked
              && element.id !== self.id
              && element.type !== 'slideshow'
              && element.type !== 'data'
              && element.type !== 'sheet-data'
              && element.type !== 'social-data'
            );
          })
          .map((id) => {
            const element = self.findElement(id);
            return {
              id: element.id,
              element: $(`#${element.id}`),
              left: element.styles.left,
              top: element.styles.top,
            };
          });

        self.translateDrag[0].lockAxis = !!event.shiftKey;
      }

      if (this.editing) {
        if (!this.element.type.includes('social')) {
          this.translateDrag?.[0].disable();
        }
      }

      this.translateDrag = Draggable.create(this.$el, {
        type: 'top,left',
        zIndexBoost: false,
        minimumMovement: 10,
        allowEventDefault: true,
        liveSnap(endValue) {
          return Math.round(endValue / 10) * 10;
        },
        onDrag: setPosition,
        onPress,
        dragClickables: true,
        onRelease() {
          // didn't move, do nothing
          if (startX === this.x && startY === this.y) return;

          self.$nextTick(async () => {
            if (self.parent !== 'root') {
              // updating any group bounds
              await self.onMoveOrResize({
                value: {
                  groupId: self.parent,
                },
              });
            }

            for (let i = 0; i < companions.length; i += 1) {
              const cId = companions[i].id;
              const cParent = self.getElementParentGroupId(cId);
              if (cParent !== 'root') {
                // updating any companion group bounds
                self.onMoveOrResize({
                  value: {
                    groupId: cParent,
                  },
                });
              }
            }
            EventBus.emit('sync-all');
          });
        },
      });

      if (!this.canTranslateDrag()) this.translateDrag[0].disable();
    },

    findElement(id) {
      return this.getElementById(id);
    },

    syncAll() {
      if (!this.styles) return;
      const $this = $(this.$el);
      // not sure why this is needed but it is
      this.$nextTick(() => {
        TweenMax.set($this, {
          width: this.styles.width,
          height: this.styles.height,
          top: this.styles.top,
          left: this.styles.left,
        });

        this.translateDrag?.[0]?.update();
      });
    },
    setSize(size) {
      const $this = $(this.$el);

      if (
        (!this.editing && this.isSelected)
        || (size.force === true && size.id === this.id)
      ) {
        // force allows override of size when editing
        TweenMax.set($this, {
          width: Number(size.width),
          height: Number(size.height),
        });

        this.translateDrag?.[0]?.update();
      }
    },
    setAlignment(opts) {
      // Ignore event if current element is not selected
      if (this.editing || !this.isSelected || !this.styles) {
        return;
      }

      const { align, positions } = opts;

      const $this = $(this.$el);
      const update = {};

      const width = this.styles?.width || 0;
      const height = this.styles?.height || 0;

      switch (align) {
        case 'left': {
          update.left = Math.round(positions.left);
          break;
        }

        // Align horizontal center of element with horizontal center of provided position
        case 'center': {
          // First get absolute position of current element.
          const absolutePos = this.getAbsolutePosition(
            this.id,
            this.parents,
          );

          // Grab the center point of the current element, and the target center point
          const center = Math.round(absolutePos.left + absolutePos.width / 2);
          const newCenter = Math.round(positions.left + positions.width / 2);

          // Add the different to the current left value
          const delta = newCenter - center;
          update.left = absolutePos.left + delta;
          break;
        }

        case 'right': {
          update.left = Math.round(positions.right - width);
          break;
        }

        case 'top': {
          update.top = Math.round(positions.top);
          break;
        }

        // Align vertical center of element with vertical center of provided position
        case 'middle': {
          // First get absolute position of current element.
          const absolutePos = this.getAbsolutePosition(
            this.id,
            this.parents,
          );

          // Grab the center point of the current element, and the target center point
          const center = Math.round(absolutePos.top + absolutePos.height / 2);
          const newCenter = Math.round(positions.top + positions.height / 2);

          // Add the different to the current top
          const delta = newCenter - center;
          update.top = absolutePos.top + delta;
          break;
        }

        case 'bottom': {
          update.top = Math.round(positions.bottom - height);
          break;
        }

        default:
          return;
      }

      // Adjust position relative to ALL parents (if element has multiple)
      this.parents.forEach((parent) => {
        if (parent !== 'root') {
          const styles = this.getElementValueByProp(parent, 'styles');
          // Child has a parent, so adjust position to be relative
          if ('top' in update) {
            update.top -= styles?.top || 0;
          }
          if ('left' in update) {
            update.left -= styles?.left || 0;
          }
        }
      });
      this.updateElementProp({
        id: this.id,
        propKey: 'styles',
        propValue: {
          ...this.styles,
          ...update,
        },
      });
      TweenMax.set($this, update);
      this.translateDrag[0].update();
    },

    snapPosition(snap) {
      const safeArea = this.getSafeArea;
      const canvas = this.getCanvas;
      const { width, height } = canvas;

      let { height: elementHeight, width: elementWidth } = this.styles;

      // If element is a data-list,
      // then snapping should be done using the entire group instead of just the first values
      if (this.type === 'data-list' && this.size) {
        elementHeight = this.size.height || elementHeight;
        elementWidth = this.size.width || elementWidth;
      }

      const safeAreaTopEdgePercentage = (100 - safeArea.height) / 2 / 100;
      const safeAreaBottomEdgePercentage = (100 - (100 - safeArea.height) / 2) / 100;
      const safeAreaLeftEdgePercentage = (100 - safeArea.width) / 2 / 100;
      const safeAreaRightEdgePercentage = (100 - (100 - safeArea.width) / 2) / 100;

      const topEdge = safeArea.show
        ? height * safeAreaTopEdgePercentage
        : 0;
      const bottomEdge = safeArea.show
        ? height * safeAreaBottomEdgePercentage
        : height;
      const leftEdge = safeArea.show
        ? width * safeAreaLeftEdgePercentage
        : 0;
      const rightEdge = safeArea.show
        ? width * safeAreaRightEdgePercentage
        : width;

      if (!this.editing && this.isSelected) {
        switch (snap) {
          // TODO: With the new setMany store function we can clean this stuff up to be less verbose
          // change the updateStyles to setManyElementValuesByProp
          case 'center':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: height / 2 - elementHeight / 2,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: width / 2 - elementWidth / 2,
            });
            break;
          case 'center-top':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: topEdge,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: width / 2 - elementWidth / 2,
            });
            break;
          case 'center-bottom':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: bottomEdge - elementHeight,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: width / 2 - elementWidth / 2,
            });
            break;
          case 'center-left':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: height / 2 - elementHeight / 2,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: leftEdge,
            });
            break;
          case 'center-right':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: height / 2 - elementHeight / 2,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: rightEdge - elementWidth,
            });
            break;
          case 'bottom-left':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: bottomEdge - elementHeight,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: leftEdge,
            });
            break;
          case 'bottom-right':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: bottomEdge - elementHeight,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: rightEdge - elementWidth,
            });
            break;
          case 'top-right':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: topEdge,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: rightEdge - elementWidth,
            });
            break;
          case 'top-left':
            this.updateStyles({
              id: this.id,
              propKey: 'top',
              propValue: topEdge,
            });
            this.updateStyles({
              id: this.id,
              propKey: 'left',
              propValue: leftEdge,
            });
            break;
          default:
            return;
        }

        // Adjust position relative to ALL parents (if element has multiple)
        this.parents.forEach((parent) => {
          // Child has a parent, so adjust position to be relative
          if (parent !== 'root') {
            const styles = this.getElementValueByProp(parent, 'styles');
            const top = this.element.styles.top - (styles?.top || 0);
            const left = this.element.styles.left - (styles?.left || 0);
            if ('top' in this.styles) {
              this.updateStyles({
                id: this.id,
                propKey: 'top',
                propValue: top,
              });
              if ('left' in this.styles) {
                this.updateStyles({
                  id: this.id,
                  propKey: 'left',
                  propValue: left,
                });
              }
            }
          }
        });

        TweenMax.set(this.$el, {
          parseTransform: true,
          x: 0,
          y: 0,
          left: this.styles.left,
          top: this.styles.top,
        });

        this.translateDrag[0].update();

        if (this.parent !== 'root') {
          this.onMoveOrResize({
            value: {
              groupId: this.parent,
            },
          });
        }
      }
    },
  },

  beforeUnmount() {
    EventBus.off('snap-position', this.snapPosition);
    EventBus.off('set-alignment', this.setAlignment);
    EventBus.off('sync-all', this.syncAll);
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('keyup', this.onKeyUp);
  },
};
